/* What the Teacher notes section shows: the teacher's recap and their notes (e.g. why late/early). */
const clean = (v) => (typeof v === 'string' ? v.trim() : '');

// The 1-on-1 API sends these at the top level; the group session API only inside raw_data.
const pick = (details, key) => {
  const d = details || {};
  if (d[key] !== undefined && d[key] !== null) return d[key];
  return d.raw_data ? d.raw_data[key] : undefined;
};

export const teacher_notes_view = (details) => {
  const recap = clean(pick(details, 'recap'));
  const notes = clean(pick(details, 'notes'));
  return {
    recap,
    notes,
    notes_created_at: pick(details, 'notes_created_at') || null,
    notes_updated_at: pick(details, 'notes_updated_at') || null,
    is_empty: !recap && !notes
  };
};
